import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-single-company-dashboard-page',
  templateUrl: './single-company-dashboard-page.component.html',
  styleUrls: ['./single-company-dashboard-page.component.scss']
})
export class SingleCompanyDashboardPageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/onboarding/components/single-company-dashboard-page/single-company-dashboard-page.component.ts